import React from "react";

import { useContext } from "../Context";

import Cards from "react-credit-cards";

export default function Index() {
  const { state } = useContext();

  return (
    <Cards
      issuer={state.paymentMethod.attributes.options.brand}
      expiry={`${state.paymentMethod.attributes.options.exp_month}/${state.paymentMethod.attributes.options.exp_year}`}
      number={`************${state.paymentMethod.attributes.options.last4}`}
      preview={true}
      name={state.paymentMethod.attributes.options.name}
    />
  );
}
